import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Profile Update")
], -1 /* HOISTED */)
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "mb-3 row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "userId",
  class: "col-sm-6 col-form-label"
}, "UserId:", -1 /* HOISTED */)
const _hoisted_6 = { class: "col-sm-6" }
const _hoisted_7 = {
  class: "form-control-plaintext",
  id: "userId"
}
const _hoisted_8 = { class: "mb-3 row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "givenName",
  class: "col-sm-6 col-form-label"
}, [
  /*#__PURE__*/_createTextVNode("Given Name"),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
], -1 /* HOISTED */)
const _hoisted_10 = { class: "col-sm-6" }
const _hoisted_11 = {
  key: 0,
  class: "mb-3 row"
}
const _hoisted_12 = { style: {"color":"red","margin-left":"28%","text-align":"left"} }
const _hoisted_13 = { class: "mb-3 row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "familyName",
  class: "col-sm-6 col-form-label"
}, [
  /*#__PURE__*/_createTextVNode("Family Name"),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
], -1 /* HOISTED */)
const _hoisted_15 = { class: "col-sm-6" }
const _hoisted_16 = {
  key: 1,
  class: "mb-3 row"
}
const _hoisted_17 = { style: {"color":"red","margin-left":"28%","text-align":"left"} }
const _hoisted_18 = { class: "mb-3 row" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  for: "stationCode",
  class: "col-sm-6 col-form-label"
}, "Station Code:", -1 /* HOISTED */)
const _hoisted_20 = { class: "col-sm-6" }
const _hoisted_21 = {
  class: "form-control-plaintext",
  id: "stationCode"
}
const _hoisted_22 = { class: "mb-3 row" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "col-sm-6 col-form-label"
}, "E-mail:", -1 /* HOISTED */)
const _hoisted_24 = { class: "col-sm-6" }
const _hoisted_25 = {
  class: "form-control-plaintext",
  id: "email"
}
const _hoisted_26 = { class: "mb-3 row" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", {
  for: "title",
  class: "col-sm-6 col-form-label"
}, "Title:", -1 /* HOISTED */)
const _hoisted_28 = { class: "col-sm-6" }
const _hoisted_29 = { class: "mb-3 row" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", {
  for: "department",
  class: "col-sm-6 col-form-label"
}, "Department:", -1 /* HOISTED */)
const _hoisted_31 = { class: "col-sm-6" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("hr", { class: "horizontal-line" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode($setup["Navigation"]),
    _createVNode($setup["Alert"], {
      alertMessage: $setup.alertMessage,
      alertState: $setup.alertState
    }, null, 8 /* PROPS */, ["alertMessage", "alertState"]),
    _createVNode($setup["UserLinkNavigation"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString($setup.cognitoUserName), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              id: "givenName",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.givenName) = $event)),
              onKeydown: _cache[1] || (_cache[1] = ($event: any) => ($setup.txtOnKeyDown($event))),
              onKeyup: _cache[2] || (_cache[2] = ($event: any) => ($setup.checkAlphabet($event))),
              onChange: _cache[3] || (_cache[3] = ($event: any) => ($setup.checkAlphabet($event)))
            }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
              [_vModelText, $setup.givenName]
            ])
          ])
        ]),
        ($setup.givenNameError != '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_12, _toDisplayString($setup.givenNameError), 1 /* TEXT */)
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              id: "familyName",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.familyName) = $event)),
              onKeydown: _cache[5] || (_cache[5] = ($event: any) => ($setup.txtOnKeyDown($event))),
              onKeyup: _cache[6] || (_cache[6] = ($event: any) => ($setup.checkAlphabet($event))),
              onChange: _cache[7] || (_cache[7] = ($event: any) => ($setup.checkAlphabet($event)))
            }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
              [_vModelText, $setup.familyName]
            ])
          ])
        ]),
        ($setup.familyNameError != '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_17, _toDisplayString($setup.familyNameError), 1 /* TEXT */)
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("p", _hoisted_21, _toDisplayString($setup.stationCode) + "-" + _toDisplayString($setup.companyName), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("p", _hoisted_25, _toDisplayString($setup.email), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              id: "title",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.title) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.title]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              id: "department",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.department) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.department]
            ])
          ])
        ]),
        _hoisted_32,
        _createElementVNode("button", {
          class: "btn btn-primary button-design",
          onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.updateUserInfo()))
        }, " Save Changes ")
      ])
    ])
  ]))
}